import DragDropSorting from "../sorting/DragDropSorting";

/**
 * @deprecated Use DragDropSorting instead
 */
export default class DragDropImages extends DragDropSorting { }
